module.exports = __webpack_public_path__ + "static/media/Pic-0171.80228ca4.jpg";